module.exports = __webpack_public_path__ + "static/media/picnic.0d3f27a5.png";